module.exports = __webpack_public_path__ + "img/bike.90e227ad.jpg";